/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class FormRoute extends Route {
  // Services
  @service
  router;

  @service
  session;

  @service
  store;

  model() {
    // TODO: Add campusId when campuses are implemented
    return hash({
      schemas: this.store.query('enrolments/schema', {
        schoolId: this.get('session.activeSchool'),
      }),
      fieldGroups: this.store.query('people-schema/group', {
        personType: PersonType.LEARNER,
      }), // Preload
      learnerFields: this.store.query('people-schema/field', {
        personType: PersonType.LEARNER,
      }),
      caregiverFields: this.store.query('people-schema/field', {
        personType: PersonType.CAREGIVER,
      }),
      medicalFields: this.store.query('people-schema/field', {
        personType: PersonType.DOCTORS_AND_SPECIALISTS,
      }),
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    // Extract or create a schema object
    if (isEmpty(model.schemas)) {
      let school = this.get('session.school');
      controller.set(
        'schema',
        this.store.createRecord('enrolments/schema', {
          schoolId: school,
          schoolName: school.get('name'),
          jurisdiction: school.get('jurisdiction'),
          countryCode: 'NZ',
          schoolCode: this.get('session.school.jurisdictionalId'),
          primaryContacts: {
            count: 3,
            index: 1,
            title: 'Primary Contact(s)',
          },
          emergencyContacts: {
            count: 2,
            index: 2,
            title: 'Emergency Contact(s)',
            description:
              'Who should the school contact in case of an emergency, if the Primary Contacts are unreachable?',
          },
          medicalContacts: {
            count: 2,
            index: 3,
            title: 'Medical Contact(s)',
          },
          medicalConditions: {
            count: 3,
            index: 4,
            title: 'Medical Condition(s)',
          },
        }),
      );
    } else {
      // Get the latest schema from the list of all, sorted by when it was last updated
      controller.set(
        'schema',
        model.schemas
          .slice()
          .sort((a, b) => a.createTime - b.createTime)
          .at(-1),
      );
    }
  }

  init() {
    super.init(...arguments);

    this.router.on('routeWillChange', (transition) => {
      if (
        isEmpty(transition.from) ||
        !transition.from.find((route) => route.name === this.routeName)
      ) {
        return;
      }
      if (!transition.to.find((route) => route.name === this.routeName)) {
        if (this.get('controller.recordIsDirty')) {
          if (
            window.confirm(
              'You have unsaved changes which will be lost if you leave this page.  Are you sure you wish to leave?',
            )
          ) {
            this.get('controller.schema').rollbackAttributes();
          } else {
            transition.abort();
          }
        }
      }
    });
  }
}
